import React, {memo} from 'react';
import cn from 'classnames';
import styles from './TextButton.css';

const sizeTypeStyles = {
	compact: styles.sizeCompact,
	medium: styles.sizeMedium,
};

type NativeButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

interface TextButtonProps extends NativeButtonProps {
	sizeType?: 'compact' | 'medium';
}

export const TextButton = memo<TextButtonProps>(props => {
	const {className, sizeType, children, ...nativeProps} = props;

	return (
		<button
			className={cn(styles.root, sizeType && sizeTypeStyles[sizeType], className)}
			type='button'
			{...nativeProps}>
			{children}
		</button>
	);
});

TextButton.displayName = 'TextButton';
